import { render, staticRenderFns } from "./GenerationComponent.vue?vue&type=template&id=58d5946c&"
import script from "./GenerationComponent.vue?vue&type=script&lang=js&"
export * from "./GenerationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports